import Material from '@components/common/faq-material'
import { useState } from 'react'
import { FastlyImage } from '@components/common/image'
import { t } from '@lingui/macro'

const Faq = () => {
  const [activeAccordion, setActiveAccordion] = useState('')
  return (
    <div className="flex justify-center lg:justify-start flex-wrap pb-20 bg-grey-100 container m-auto lg:pl-10">
      <div>
        <FastlyImage
          src="/images/home/faq.png"
          webpSrc="/images/home/faq.webp"
          alt={t`kids cheering FAQ`}
          className="mt-5 md:mt-20"
          height={128}
          width={128}
        />
      </div>

      <div className="flex md:mt-16 flex-col px-10 lg:px-0 lg:pl-10 w-full md:w-5/6 ">
        <h2 className="text-3xl font-600 text-grey-900 text-center md:text-left">
          FAQ
        </h2>
        <div className="flex justify-around mt-4 flex-col">
          <Material
            title="What are online coding challenges?"
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
            isLightBorder
          >
            <p className="text-base text-grey pb-4">
              Coding challenges include a plethora of competitions like
              hackathons, programming challenges, and more. They are aimed at
              challenging your coding skills. Hackathons generally include
              developing an app/game/website based on a particular theme.
              Whereas programming challenges are time-bound activities that need
              participants to solve coding problems in a stipulated time.
            </p>
          </Material>
          <Material
            title="How will a coding competition help my child learn better?"
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
            isLightBorder
          >
            <p className="text-base text-grey pb-4">
              Coding competitions are aimed at testing your coding skills. They
              help in developing problem solving skills, cognitive functioning,
              logical thinking, and programming skills.
            </p>
          </Material>
          <Material
            title="Where can I participate in coding competitions?"
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
            isLightBorder
          >
            <p className="text-base text-grey pb-4">
              For beginner coders - Codingal, Google Kickstart, CodeWars
              <br />
              For intermediate coders - CodeFight, CodinGame, Codingal
              <br />
              For advanced coders - CodeChef, TopCoder, HackerRank
            </p>
          </Material>
          <Material
            title="How can practicing coding through competitions help me prepare for IOI, ZCO?"
            activeAccordion={activeAccordion}
            setActiveAccordion={setActiveAccordion}
            isLightBorder
          >
            <p className="text-base text-grey pb-4">
              Participating in coding competitions helps you come across a
              variety of coding problems based on data structures and
              algorithms. The more you practice and rank in these competitions
              it will help you increase your speed and accuracy to solve
              problems in the qualifying competitions for IOI.
            </p>
          </Material>
        </div>
      </div>
    </div>
  )
}

export default Faq
